import API, { graphqlOperation } from "@aws-amplify/api";
import * as mutations from "../../graphql/mutations";
import * as queries from "../../graphql/queries";
import { makeGraphQLRequest } from "..";
const updateUser = async (id, args) => {
  try {
    // First, fetch the current version of the User
    const getUserResponse = await makeGraphQLRequest(
      graphqlOperation(queries.getUser, { id })
    );
    const currentUser = getUserResponse.data.getUser;

    // Prepare the update input
    const updateInput = { id, _version: currentUser._version };
    args.forEach((arg) => {
      updateInput[arg.property] = arg.value;
    });

    const response = await makeGraphQLRequest(
      graphqlOperation(mutations.updateUser, { input: updateInput })
    );
    return response.data.updateUser;
  } catch (error) {
    console.error("Error updating User:", error);
    throw error;
  }
};

const updateWorkspace = async (id, args) => {
  try {
    // First, fetch the current version of the Workspace
    const getWorkspaceResponse = await makeGraphQLRequest(
      graphqlOperation(queries.getWorkspace, { id })
    );
    const currentWorkspace = getWorkspaceResponse.data.getWorkspace;

    // Prepare the update input
    const updateInput = { id, _version: currentWorkspace._version };
    args.forEach((arg) => {
      updateInput[arg.property] = arg.value;
    });

    const response = await makeGraphQLRequest(
      graphqlOperation(mutations.updateWorkspace, { input: updateInput })
    );
    return response.data.updateWorkspace;
  } catch (error) {
    console.error("Error updating Workspace:", error);
    throw error;
  }
};

const deleteUser = async (id) => {
  try {
    // First, fetch the current version of the User
    const getUserResponse = await makeGraphQLRequest(
      graphqlOperation(queries.getUser, { id })
    );
    const currentUser = getUserResponse.data.getUser;

    const response = await makeGraphQLRequest(
      graphqlOperation(mutations.deleteUser, {
        input: { id, _version: currentUser._version },
      })
    );
    return response.data.deleteUser;
  } catch (error) {
    console.error("Error deleting User:", error);
    throw error;
  }
};

export default {
  updateUser,
  updateWorkspace,
  deleteUser,
};
